<div class="crew-modal-overlay" *ngIf="item" (click)="close.emit()">
  <div class="crew-modal use-item-modal" (click)="$event.stopPropagation()">

    <div class="crew-modal-header">
      <div class="inv-modal-sprite-wrap">
        <pss-sprite *ngIf="itemSpriteId(item.designId)" class="inv-modal-sprite" [spriteId]="itemSpriteId(item.designId)"></pss-sprite>
        <span *ngIf="!itemSpriteId(item.designId)" class="inv-modal-sprite-ph">?</span>
      </div>
      <div class="inv-modal-header-info">
        <span class="crew-rarity rarity-{{ itemRarity(item.designId) | lowercase }}">{{ itemRarity(item.designId) || 'Item' }}</span>
        <span class="crew-modal-name">{{ itemName(item.designId) }}</span>
      </div>
      <button class="crew-modal-close" (click)="close.emit()" [disabled]="running">✕</button>
    </div>

    <div class="crew-modal-body">

      <ng-container *ngIf="!running && !done">
        <div class="use-item-count-row">
          <span class="crew-modal-label">How many to use?</span>
          <div class="use-item-count-controls">
            <button class="use-count-btn" (click)="setCount(1)" [disabled]="count <= 1">«</button>
            <button class="use-count-btn" (click)="setCount(count - 1)" [disabled]="count <= 1">−</button>
            <input class="use-count-input" type="number" [ngModel]="count" (ngModelChange)="setCount($event)" [min]="1" [max]="maxCount">
            <button class="use-count-btn" (click)="setCount(count + 1)" [disabled]="count >= maxCount">+</button>
            <button class="use-count-btn" (click)="setCount(maxCount)" [disabled]="count >= maxCount">»</button>
          </div>
        </div>
        <div class="use-item-avail">{{ maxCount }} available</div>
        <ng-container *ngIf="showFireOptions">
          <label class="use-item-fire-toggle">
            <input type="checkbox" [ngModel]="fireCommon" (ngModelChange)="fireCommonChange.emit($event)">
            Fire all 1★ crew (Common)
          </label>
          <label class="use-item-fire-toggle">
            <input type="checkbox" [ngModel]="fireElite" (ngModelChange)="fireEliteChange.emit($event)">
            Fire all 2★ crew (Elite)
          </label>
          <div class="use-item-fire-hint" *ngIf="fireHint">{{ fireHint }}</div>
        </ng-container>
        <div class="error-msg" *ngIf="error">{{ error }}</div>
      </ng-container>

      <ng-container *ngIf="running || done">
        <div class="use-item-progress-row">
          <span class="use-item-progress-label" *ngIf="running">Opening... {{ progress }} / {{ total }}</span>
          <span class="use-item-progress-label use-item-done-label" *ngIf="done">Done! Used {{ progress }} of {{ total }}</span>
          <div class="use-item-progress-bar">
            <div class="use-item-progress-fill" [style.width.%]="total > 0 ? (progress / total * 100) : 0"></div>
          </div>
        </div>
        <div class="use-item-retry-msg" *ngIf="retryMsg">{{ retryMsg }}</div>
        <div class="error-msg" *ngIf="error">{{ error }}</div>
      </ng-container>

      <ng-container *ngIf="characters.length > 0">
        <div class="use-item-results-header">
          <span class="crew-modal-section-title">New Characters</span>
        </div>
        <div class="use-item-results">
          <div class="use-result-entry use-character-entry" *ngFor="let c of characters"
               [ngClass]="'rarity-' + crewRarity(c).toLowerCase()"
               [class.use-result-fired]="isFired(c)"
               (click)="openCharacterFlyout(c)">
            <div class="use-result-sprite-wrap">
              <pss-sprite *ngIf="characterSpriteId(c)" class="use-result-sprite" [spriteId]="characterSpriteId(c)" [alt]="characterName(c)"></pss-sprite>
              <span *ngIf="!characterSpriteId(c)" class="use-result-sprite-ph">?</span>
            </div>
            <div class="use-result-name-block">
              <span class="use-result-name crew-modal-name" [class]="'rarity-' + crewRarity(c).toLowerCase()">{{ characterName(c) }}</span>
              <span class="use-result-tier">{{ crewRarity(c) | titlecase }}<span class="use-result-fired-badge" *ngIf="isFired(c)">Fired</span></span>
            </div>
          </div>
        </div>

        <app-crew-flyout
          *ngIf="selectedCharacter"
          [crew]="selectedCharacter"
          [characterDesigns]="characterDesigns"
          [itemDesigns]="itemDesigns"
          [inventory]="inventory"
          (close)="closeCharacterFlyout()">
        </app-crew-flyout>
      </ng-container>

      <ng-container *ngIf="results.length > 0">
        <div class="use-item-results-header">
          <span class="crew-modal-section-title">Rewards</span>
          <label class="use-item-group-toggle">
            <input type="checkbox" [ngModel]="grouped" (ngModelChange)="groupedChange.emit($event)"> Group
          </label>
        </div>

        <div class="use-item-results" *ngIf="grouped">
          <div class="use-result-entry" *ngFor="let r of groupedResults"
               [class.use-result-selected]="selectedReward === r.rewardDesignId"
               (click)="toggleReward(r.rewardDesignId)"
               [title]="itemName(r.rewardDesignId)">
            <div class="use-result-sprite-wrap">
              <pss-sprite *ngIf="itemSpriteId(r.rewardDesignId)" class="use-result-sprite" [spriteId]="itemSpriteId(r.rewardDesignId)"></pss-sprite>
              <span *ngIf="!itemSpriteId(r.rewardDesignId)" class="use-result-sprite-ph">?</span>
            </div>
            <span class="use-result-name" [class]="'rarity-' + (itemRarity(r.rewardDesignId) | lowercase)">{{ itemName(r.rewardDesignId) }}</span>
            <span class="use-result-qty">×{{ r.totalQty }}</span>
          </div>
        </div>

        <div class="use-item-results" *ngIf="!grouped">
          <div class="use-result-entry" *ngFor="let r of results"
               [class.use-result-selected]="selectedReward === r.rewardDesignId"
               (click)="toggleReward(r.rewardDesignId)"
               [title]="itemName(r.rewardDesignId)">
            <div class="use-result-sprite-wrap">
              <pss-sprite *ngIf="itemSpriteId(r.rewardDesignId)" class="use-result-sprite" [spriteId]="itemSpriteId(r.rewardDesignId)"></pss-sprite>
              <span *ngIf="!itemSpriteId(r.rewardDesignId)" class="use-result-sprite-ph">?</span>
            </div>
            <span class="use-result-name" [class]="'rarity-' + (itemRarity(r.rewardDesignId) | lowercase)">{{ itemName(r.rewardDesignId) }}</span>
            <span class="use-result-qty">×{{ r.rewardQty }}</span>
          </div>
        </div>

        <ng-container *ngIf="selectedReward && itemDesigns.get(selectedReward) as d">
          <div class="use-item-preview-panel">
            <div class="use-item-preview-header">
              <div class="use-result-sprite-wrap">
                <pss-sprite *ngIf="itemSpriteId(selectedReward)" class="use-result-sprite" [spriteId]="itemSpriteId(selectedReward)"></pss-sprite>
                <span *ngIf="!itemSpriteId(selectedReward)" class="use-result-sprite-ph">?</span>
              </div>
              <div class="use-item-preview-info">
                <span class="crew-rarity rarity-{{ itemRarity(selectedReward) | lowercase }}">{{ itemRarity(selectedReward) }}</span>
                <span class="use-item-preview-name">{{ d.name }}</span>
              </div>
            </div>
            <div class="use-item-preview-row" *ngIf="d.enhancementType && d.enhancementType !== 'None' && d.enhancementType !== ''">
              <span class="crew-modal-label">Bonus</span>
              <span class="inv-stat-bonus">{{ d.enhancementType }} +{{ d.modifier }}</span>
            </div>
            <p class="use-item-preview-desc" *ngIf="d.description">{{ d.description }}</p>
          </div>
        </ng-container>
      </ng-container>

    </div>

    <div class="modal-warning-note">
      Do you love this feature and don't hate me? Donate <a [href]="supportUrl" target="_blank" rel="noopener noreferrer">here!</a>
    </div>
    <div class="modal-footer">
      <button class="btn btn-ghost btn-sm" (click)="close.emit()" [disabled]="running">
        {{ done ? 'Close' : 'Cancel' }}
      </button>
      <button class="btn btn-warning btn-sm" *ngIf="!running && !done"
              (click)="start.emit()"
              [disabled]="count < 1 || count > maxCount">
        Open {{ count > 1 ? count + ' Items' : 'Item' }}
      </button>
    </div>

  </div>
</div>
